import React from "react";
import Shimmer from "./Shimmer";

function ListItem() {
  return (
    <li className="loading-list list collection center container">
      <section className="loading-crypto-rank"></section>
      <div className="loading-crypto-name"></div>
      <p className="loading-crypto-price"></p>
      <Shimmer />
    </li>
  );
}

export default ListItem;
